class StringTemplate<T> extends String
{
  apply(params: T): string
  {
    const args = params as unknown as {[key: string | number]: string};
    let result = this.toString();
    for (const key of Object.getOwnPropertyNames(args))
    {
      ;
      result = result.replace(new RegExp("\\{" + key + "\\}", "gi"), `${args[key]}`);
    }
    return result;
  }
}

const labels =
{
  common:
  {
    anErrorOccured: 'An error occured',
    loading: 'Loading...',
    tryAgain: 'Try Again',
    noResults: 'No results found for your request',
    clipboard:
    {
      tip: 'Copy to clipboard',
      copied: 'copied',
    },
    forms:
    {
      add: 'Add',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      createAnother: 'Create Another',
      toList: 'To List',
      feature:
      {
        token: { label: 'Token', },
        name: { label: 'Name', placeholder: 'Enter a descriptive name', },
        description: { label: 'Description', placeholder: 'Enter useful notes about the feature', },
        createdBy: new StringTemplate<{by?: string, at?: string}>('Created by {by} on {at}'),
        updatedBy: new StringTemplate<{by?: string, at?: string}>('Updated by {by} on {at}'),
      },
      requester:
      {
        token: { label: 'Token', },
        name: { label: 'Name', placeholder: 'Enter a descriptive name', },
        path: { label: 'Scope Partition', placeholder: 'Enter a scope partition to associate with', },
        createdBy: new StringTemplate<{by?: string, at?: string}>('Created by {by} on {at}'),
        updatedBy: new StringTemplate<{by?: string, at?: string}>('Updated by {by} on {at}'),
      },
      requesterToken:
      {
        token: { label: 'Token', placeholder: 'Emter a unique token value', },
        requester: { label: 'Requester', placeholder: 'Select a requester to associate with', suggestionsInstruction: 'Start typing to get some options', },
        createdBy: new StringTemplate<{by?: string, at?: string}>('Created by {by} on {at}'),
        updatedBy: new StringTemplate<{by?: string, at?: string}>('Updated by {by} on {at}'),
      },
      createToggle:
      {
        feature: { placeholder: 'Select a feature', suggestionsInstruction: 'Start typing to get some options', },
        scope: { placeholder: 'Specify a scope', suggestionsInstruction: 'Start typing to get some suggestions', },
        errors:
        {
          featureRequired: 'Select a feature please',
        },
      },
    }
  },
  pages:
  {
    header:
    {
      menu:
      {
        features: 'Features',
        toggles: 'Toggles',
        audience: 'Audience',
      }
    },
    footer:
    {
      copyright: new StringTemplate<{yearInfo: string}>('© RBmedia {yearInfo}. All rights reserved.'),
    },
    notFound:
    {
      title: 'Page Not Found',
      explanationLines: ['The page you are looking for cannot be found',],
      toDashboard: 'Go To Dashboard',
    },
    accessDenied:
    {
      title: 'Access Denied',
      explanationLines: ['You currently don’t have access to this page.', 'Ask admin to give you permissions',],
      toDashboard: 'Go To Dashboard',
    },
    login:
    {
      titleLines: ['RBMedia', 'Feature Gating'],
      logIn: 'Log In',
      failed:
      {
        title: 'Authorization Failed',
        explanationLines: ['Something went wrong.', 'Please try to authorize again',],
        tryAgain: 'Try Again',
      },
    },
    dashboard:
    {
      title: 'Feature Gating',
      cards:
      {
        feature:
        {
          title: 'Features',
          description: 'Define product features you want to control',
        },
        toggle:
        {
          title: 'Toggles',
          description: 'Manage the state of your product features',
        },
        audience:
        {
          title: 'Audience',
          description: 'Have it different for different audience',
        },
      }
    },
    features:
    {
      title: 'Features',
      createNewFeature: 'Create a New Feature',
      searchForFeatures: 'Search for features',
      table:
      {
        tokenColumnName: 'Token',
        nameColumnName: 'Name',
        descriptionColumnName: 'Description',
      },
      deleteFeatureConfirmation: new StringTemplate<{featureName?: string}>('Are you sure you want to detele "{featureName}" feature?'),
      viewDetailsOfFeature: new StringTemplate<{featureName?: string}>('View details of the "{featureName}" feature'),
      editFeature: new StringTemplate<{featureName?: string}>('Edit "{featureName}" feature'),
      deleteFeature: new StringTemplate<{featureName?: string}>('Delete "{featureName}" feature'),
      pages:
      {
        featureCreate:
        {
          title: 'Create a New Feature',
        },
        featureEdit:
        {
          title: new StringTemplate<{featureName?: string}>('Edit "{featureName}" feature'),
        },
      }
    },
    toggles:
    {
      title: 'Toggles',
      deleteToggleConfirmation: new StringTemplate<{featureName?: string, scope?: string}>('Are you sure you want to detele the toggle\nof "{featureName}" feature in "{scope}" scope?'),
    },
    audience:
    {
      title: 'Audience',

      tabs:
      {
        requesters: 'Requesters',
        tokens: 'Tokens',
      },

      createNewRequester: 'Create a New Requester',
      searchForRequesters: 'Search for requesters',
      deleteRequesterConfirmation: new StringTemplate<{requesterName?: string}>('Are you sure you want to detele "{requesterName}" requester?'),
      viewDetailsOfRequester: new StringTemplate<{requesterName?: string}>('View details about the "{requesterName}" requester'),
      editRequester: new StringTemplate<{requesterName?: string}>('Edit "{requesterName}" requester'),
      deleteRequester: new StringTemplate<{requesterName?: string}>('Delete "{requesterName}" requester'),
      requestersTable:
      {
        tokenColumnName: 'Token',
        nameColumnName: 'Name',
        pathColumnName: 'Scope Partition',
      },

      createNewRequesterToken: 'Create a New Token',
      searchForRequesterTokens: 'Search for tokens',
      deleteRequesterTokenConfirmation: new StringTemplate<{requesterToken?: string}>('Are you sure you want to detele "{requesterToken}" token?'),
      viewDetailsOfRequesterToken: new StringTemplate<{requesterToken?: string}>('View details of the "{requesterToken}" token'),
      editRequesterToken: new StringTemplate<{requesterToken?: string}>('Edit "{requesterToken}" token'),
      deleteRequesterToken: new StringTemplate<{requesterToken?: string}>('Delete "{requesterToken}" token'),
      requesterTokensTable:
      {
        tokenColumnName: 'Token',
        requesterColumnName: 'Requester',
      },

      pages:
      {
        requesterCreate:
        {
          title: 'Create a New Requester',
        },
        requesterEdit:
        {
          title: new StringTemplate<{requesterName?: string}>('Edit "{requesterName}" requester'),
        },
        requesterTokenCreate:
        {
          title: 'Create a New Requester Token',
        },
        requesterTokenEdit:
        {
          title: new StringTemplate<{requesterToken?: string}>('Edit "{requesterToken}" token'),
        },
      }
    },
  },
  help:
  {
    tip: 'Click to show or hide the help',
    features:
    {
      about: 'Features are defining aspects of your product you will be able to control using feature toggles.',
      token:
      {
        about: 'This token represents an immutable external identifier of a feature. Use it whenever you need to refer to an exact feature, e.g., when you need to call the API.',
      }
    },
    toggles:
    {
      about: 'Toggles are defining if a feature is enabled or disabled for an application, user, or group of users. It uses scopes to achieve this. A scope is a tree-like structure similar to a filesystem. It enables you to organize toggles in a way that suits best for a system(s).',
    },
    audience:
    {
      about: 'Audience defines your applications, users, or groups of users.',
      requesters:
      {
        about: 'Requesters are defining applications, users, and groups of users. It describes the rules on how to map it to the scope path. Scope resolution is what is happening behind the scenes when you are using the audience to get the state of a feature.',
        path:
        {
          about: 'Scope partition is a part of the scope path. It is used in a scope resolution behind the scene to determine the final scope of your interest. E.g. your QA Team may have a partition "qa-team," and your application may have a partition "production/my-application." The final scope would be something like "/production/my-application/qa-team" and the search of a toggle state would be done accordingly.',
        },
      },
      requester_tokens:
      {
        about: 'Tokens is an external way to refer to your audience. It allows you to have many tokens linked with the same requester. That makes it possible to build groups of users.',
        token:
        {
          about: 'This token represents an immutable external identifier linked with a selected requester. Use it whenever you need to refer to the desired audience, e.g., when you need to call the API.',
        },
      },
    },
  },
};

export default labels;